
    <template>
      <section class="doc-article monkey-view-doc">
        <h1>DatePicker 日期选择器</h1>
<p>选择日期，支持年、月、日期的类型，支持日期的范围选择。</p>
<h2 id="dai-ma-shi-li" class="anchor-title">代码示例 <a class="header-anchor" href="#dai-ma-shi-li">#</a></h2>
<code-wrap id="JCYF">
                <template slot="description"><p>设置<code>type</code>类型为<code>date</code> <code>daterange</code>分别为日期单选和日期范围选择。</p>
<p>设置<code>placement</code>属性可以控制下拉框的位置，和tooltip组件一致。</p>
</template>
                <template slot="title">基础用法 <a href="#JCYF" data-title="基础用法">#</a></template>
                <template slot="source"><monkey-view-demo0 /></template>
                <template slot="highlight">
<p></p>
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;DatePicker placeholder=&quot;请选择日期&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;DatePicker type=&quot;daterange&quot; placement=&quot;bottom-end&quot; placeholder=&quot;请选择日期范围&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="NYZXZ">
                <template slot="description"><p>设置<code>type</code>类型为<code>year</code> <code>month</code> <code>week</code>分别为年、月和周选择器。</p>
</template>
                <template slot="title">年月周选择 <a href="#NYZXZ" data-title="年月周选择">#</a></template>
                <template slot="source"><monkey-view-demo1 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;DatePicker type=&quot;year&quot; placeholder=&quot;请选择年&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;DatePicker type=&quot;month&quot; placeholder=&quot;请选择月&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;DatePicker type=&quot;week&quot; placeholder=&quot;请选择周&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="RQSJXZ">
                <template slot="description"><p>设置<code>type</code>类型为<code>datetime</code> <code>datetimerange</code>分别为日期时间单选和日期时间范围选择。</p>
</template>
                <template slot="title">日期时间选择 <a href="#RQSJXZ" data-title="日期时间选择">#</a></template>
                <template slot="source"><monkey-view-demo2 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;DatePicker type=&quot;datetime&quot; placeholder=&quot;请选择日期时间&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;DatePicker type=&quot;datetimerange&quot; placeholder=&quot;请选择日期时间范围&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="KJFS">
                <template slot="description"><p>设置<code>shortcuts</code>属性可以定义快捷方式。<code>onClick</code>事件中返回日期选择器实例，可以调用<code>setValue</code>方法设置日期。</p>
</template>
                <template slot="title">快捷方式 <a href="#KJFS" data-title="快捷方式">#</a></template>
                <template slot="source"><monkey-view-demo3 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;DatePicker type=&quot;date&quot; placeholder=&quot;请选择日期&quot; :shortcuts=&quot;shortcuts&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;DatePicker type=&quot;daterange&quot; placeholder=&quot;请选择日期范围&quot; :shortcuts=&quot;shortcutsrange&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                shortcuts: [
                    {
                      text: '今天',
                      onClick(picker){
                          let date = new Date();
                          picker.setValue(date);
                      }
                    },
                    {
                      text: '昨天',
                      onClick(picker){
                          let date = new Date();
                          date.setDate(date.getDate() - 1);
                          picker.setValue(date);
                      }
                    },
                    {
                      text: '一周之前的某一天',
                      onClick(picker){
                          let date = new Date();
                          date.setDate(date.getDate() - 7);
                          picker.setValue(date);
                      }
                    }
                ],
                shortcutsrange: [
                    {
                      text: '最近一周',
                      onClick(picker){
                          let date1 = new Date();
                          let date2 = new Date();
                          date1.setDate(date1.getDate() - 7);
                          picker.setValue([date1, date2]);
                      }
                    },
                    {
                      text: '一个月',
                      onClick(picker){
                          let date1 = new Date();
                          let date2 = new Date();
                          date1.setDate(date1.getDate() - 30);
                          picker.setValue([date1, date2]);
                      }
                    },
                    {
                      text: '三个月',
                      onClick(picker){
                          let date1 = new Date();
                          let date2 = new Date();
                          date1.setDate(date1.getDate() - 90);
                          picker.setValue([date1, date2]);
                      }
                    }
                ],
            }
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="JYZDRQ">
                <template slot="description"><p>设置<code>disabled-date</code>属性可以指定禁用的日期，该属性值为<code>Function</code>,参数为日期，需返回Boolean值指定是否禁用该日期。</p>
</template>
                <template slot="title">禁用指定日期 <a href="#JYZDRQ" data-title="禁用指定日期">#</a></template>
                <template slot="source"><monkey-view-demo4 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;DatePicker type=&quot;date&quot; placeholder=&quot;请选择日期&quot; :disabled-date=&quot;disabledDate&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;DatePicker type=&quot;daterange&quot; placeholder=&quot;请选择日期范围&quot; :disabled-date=&quot;disabledDate&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                
            }
        },
        methods: {
            disabledDate(date){
                return date &amp;&amp; new Date(date).getTime() &lt; Date.now();
            },
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="GSHRQ">
                <template slot="description"><p>设置<code>format</code>属性可以格式化日期。</p>
<p>该值格式为<code>yyyy-MM-dd hh:mm:ss</code>。</p>
<p>默认值如下：</p>
<p><code>type=date</code>和<code>type=daterange</code>: <code>yyyy-MM-dd</code>;</p>
<p><code>type=year</code>: <code>yyyy</code>;</p>
<p><code>type=month</code>: <code>yyyy-MM</code>;</p>
<p><code>type=week</code>: <code>yyyy-WW</code>;</p>
<p><code>type=datetime</code>和<code>type=datetimerange</code>: <code>yyyy-MM-dd hh:mm:ss</code>;</p>
</template>
                <template slot="title">格式化日期 <a href="#GSHRQ" data-title="格式化日期">#</a></template>
                <template slot="source"><monkey-view-demo5 /></template>
                <template slot="highlight">
<p></p>
<p></p>
<p></p>
<p></p>
<p></p>
<p></p>
<p></p>
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;DatePicker type=&quot;date&quot; placeholder=&quot;请选择日期&quot; format=&quot;yyyy年MM月dd日&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;DatePicker type=&quot;daterange&quot; placeholder=&quot;请选择日期范围&quot; format=&quot;yyyy/MM/dd&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                
            }
        },
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="GSHBDRQZ">
                <template slot="description"><p>设置<code>value-format</code>属性可以格式化绑定日期值。使用方式类似于<code>format</code>。</p>
<p>注意：<code>value-format</code>格式化后的值必须是可以被<code>new Date()</code>的日期格式，不能类似于<code>2020年01月01日</code>的格式。</p>
</template>
                <template slot="title">格式化绑定日期值 <a href="#GSHBDRQZ" data-title="格式化绑定日期值">#</a></template>
                <template slot="source"><monkey-view-demo6 /></template>
                <template slot="highlight">
<p></p>
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;p&gt;默认为Date对象&lt;/p&gt;
            &lt;p&gt;value: {{date1}}&lt;/p&gt;
            &lt;DatePicker v-model=&quot;date1&quot; placeholder=&quot;请选择日期&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;p&gt;使用value-format&lt;/p&gt;
            &lt;p&gt;value: {{date2}}&lt;/p&gt;
            &lt;DatePicker v-model=&quot;date2&quot; placeholder=&quot;请选择日期范围&quot; value-format=&quot;yyyy年MM月dd日&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;p&gt;时间戳&lt;/p&gt;
            &lt;p&gt;value: {{date3}}&lt;/p&gt;
            &lt;DatePicker v-model=&quot;date3&quot; placeholder=&quot;请选择日期&quot; value-format=&quot;timestamp&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                date1: '',
                date2: '',
                date3: '',
            }
        },
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="DX">
                <template slot="description"><p>设置<code>multiple</code>属性开启多选，只在<code>type=date</code>时有效。</p>
</template>
                <template slot="title">多选 <a href="#DX" data-title="多选">#</a></template>
                <template slot="source"><monkey-view-demo7 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;DatePicker placeholder=&quot;请选择日期&quot; multiple clearable&gt;&lt;/DatePicker&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                
            }
        },
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="XSZS">
                <template slot="description"><p>设置<code>show-week-number</code>属性显示周数。</p>
</template>
                <template slot="title">显示周数 <a href="#XSZS" data-title="显示周数">#</a></template>
                <template slot="source"><monkey-view-demo8 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;DatePicker type=&quot;date&quot; placeholder=&quot;请选择时间&quot; show-week-number clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;DatePicker type=&quot;daterange&quot; placeholder=&quot;请选择日期范围&quot; show-week-number clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                
            }
        },
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="ZDHBKSR">
                <template slot="description"><p>设置<code>readonly</code>属性开启只读。只读时不能打开日期下拉框。</p>
<p>设置<code>editable</code>属性控制是否可输入。</p>
</template>
                <template slot="title">只读和不可输入 <a href="#ZDHBKSR" data-title="只读和不可输入">#</a></template>
                <template slot="source"><monkey-view-demo9 /></template>
                <template slot="highlight">
<p></p>
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;h4&gt;只读&lt;/h4&gt;
            &lt;DatePicker type=&quot;date&quot; placeholder=&quot;请选择日期&quot; readonly clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;h4&gt;不可输入&lt;/h4&gt;
            &lt;DatePicker type=&quot;daterange&quot; placeholder=&quot;请选择日期范围&quot; :editable=&quot;false&quot; clearable&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                
            }
        },
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="JY">
                <template slot="description"><p>设置<code>disabled</code>属性禁用日期选择器。</p>
</template>
                <template slot="title">禁用 <a href="#JY" data-title="禁用">#</a></template>
                <template slot="source"><monkey-view-demo10 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;DatePicker type=&quot;date&quot; placeholder=&quot;请选择日期&quot; disabled clearable&gt;&lt;/DatePicker&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                
            }
        },
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="ZDYCFQ">
                <template slot="description"><p>可以通过<code>slot</code>自定义触发器，此时需要手动通过<code>open</code>属性控制日期面板的打开和关闭。</p>
</template>
                <template slot="title">自定义触发器 <a href="#ZDYCFQ" data-title="自定义触发器">#</a></template>
                <template slot="source"><monkey-view-demo11 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;DatePicker type=&quot;date&quot; placeholder=&quot;请选择日期&quot; :open=&quot;open&quot;&gt;
        &lt;Button type=&quot;text&quot; @click=&quot;open = !open&quot;&gt;触发日期框打开关闭&lt;/Button&gt;
    &lt;/DatePicker&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                open: false
            }
        },
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="ZXSRQK">
                <template slot="description"><p>设置<code>only-show-pane</code>属性只显示日期框。</p>
</template>
                <template slot="title">只显示日期框 <a href="#ZXSRQK" data-title="只显示日期框">#</a></template>
                <template slot="source"><monkey-view-demo12 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;DatePicker v-model=&quot;pickerDate&quot; type=&quot;date&quot; only-show-pane @change=&quot;handleChange&quot;&gt;
        &lt;template slot=&quot;paneFooter&quot;&gt;
            &lt;Button size=&quot;small&quot; @click=&quot;handleClear&quot;&gt;清除&lt;/Button&gt;
        &lt;/template&gt;
    &lt;/DatePicker&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                pickerDate: ''
            }
        },
        methods: {
            handleChange(value){
                this.$Message.info('selectd value is ' + value)
            },
            handleClear(){
                this.pickerDate = '';
            }   
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="CC">
                <template slot="description"><p>设置<code>size</code>属性控制尺寸大小，可选值 <code>mini</code> <code>small</code> <code>large</code>或者不设置。</p>
</template>
                <template slot="title">尺寸 <a href="#CC" data-title="尺寸">#</a></template>
                <template slot="source"><monkey-view-demo13 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;h4&gt;Mini&lt;/h4&gt;
            &lt;DatePicker type=&quot;date&quot; placeholder=&quot;请选择日期&quot; size=&quot;mini&quot;&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;h4&gt;Small&lt;/h4&gt;
            &lt;DatePicker type=&quot;date&quot; placeholder=&quot;请选择日期范围&quot; size=&quot;small&quot;&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;h4&gt;Default&lt;/h4&gt;
            &lt;DatePicker type=&quot;date&quot; placeholder=&quot;请选择日期范围&quot;&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;h4&gt;Large&lt;/h4&gt;
            &lt;DatePicker type=&quot;date&quot; placeholder=&quot;请选择日期范围&quot; size=&quot;large&quot;&gt;&lt;/DatePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                
            }
        },
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<h2 id="api" class="anchor-title">API <a class="header-anchor" href="#api">#</a></h2>
<h3 id="datepicker-props" class="anchor-title">DatePicker props <a class="header-anchor" href="#datepicker-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>type</td>
<td>String</td>
<td>设置日期选择器的类型，可选值 <code>date</code> <code>daterange</code> <code>datetime</code> <code>datetimerange</code> <code>year</code> <code>month</code> <code>week</code></td>
<td>date</td>
</tr>
<tr>
<td>value</td>
<td>Date, String, Array, Number</td>
<td>绑定的值，可以使用v-model进行双向绑定，<code>range</code>模式下为Array类型，<code>Number</code>类型为时间戳，数组类型是数组项值的类型为String、Date、Number</td>
<td>-</td>
</tr>
<tr>
<td>disabled</td>
<td>Boolean</td>
<td>禁用</td>
<td>-</td>
</tr>
<tr>
<td>readonly</td>
<td>Boolean</td>
<td>只读属性，只读时不能打开日期下拉框</td>
<td>-</td>
</tr>
<tr>
<td>placeholder</td>
<td>String</td>
<td>占位文本</td>
<td>-</td>
</tr>
<tr>
<td>size</td>
<td>String</td>
<td>尺寸，可选值 <code>mini</code> <code>small</code> <code>large</code>或者不设置</td>
<td>-</td>
</tr>
<tr>
<td>clearable</td>
<td>Boolean</td>
<td>显示清除图标</td>
<td>true</td>
</tr>
<tr>
<td>prefix</td>
<td>String</td>
<td>输入框前置图标。</td>
<td>-</td>
</tr>
<tr>
<td>suffix</td>
<td>String</td>
<td>输入框尾部图标。</td>
<td>date</td>
</tr>
<tr>
<td>transition</td>
<td>String</td>
<td>自定义日期下拉框的动画效果</td>
<td>fade</td>
</tr>
<tr>
<td>editable</td>
<td>Boolean</td>
<td>是否可以输入</td>
<td>true</td>
</tr>
<tr>
<td>placement</td>
<td>String</td>
<td>和<code>tooltip</code>一样</td>
<td>bottom-start</td>
</tr>
<tr>
<td>format</td>
<td>String</td>
<td>输入框展示时间的格式化；详细见示例，具体格式见下面的日期格式说明</td>
<td>-</td>
</tr>
<tr>
<td>value-format</td>
<td>String</td>
<td><code>v-model</code>绑定值时间的格式化；详细见示例，具体格式见下面的日期格式说明</td>
<td>-</td>
</tr>
<tr>
<td>shortcuts</td>
<td>Array</td>
<td>自定义快捷方式，类型如<code>[{text: 'one', onClick(picker){}}]</code>，详细见示例</td>
<td>-</td>
</tr>
<tr>
<td>disabled-date</td>
<td>Function</td>
<td>禁用日期，详细见示例</td>
<td>-</td>
</tr>
<tr>
<td>show-week-number</td>
<td>Boolean</td>
<td>是否显示周数</td>
<td>-</td>
</tr>
<tr>
<td>open</td>
<td>Boolean</td>
<td>自定义控制打开关闭日期下拉框，此时选择器不会主动关闭，结合<code>slot</code>使用。</td>
<td>-</td>
</tr>
<tr>
<td>multiple</td>
<td>Boolean</td>
<td>是否多选日期，<code>type=date</code>时有效</td>
<td>-</td>
</tr>
<tr>
<td>separator</td>
<td>String</td>
<td>range类型时，两个日期之间的分隔符</td>
<td>～</td>
</tr>
<tr>
<td>class-name</td>
<td>String</td>
<td>选择器的类名</td>
<td>-</td>
</tr>
<tr>
<td>dropdown-class-name</td>
<td>String</td>
<td>选择器下拉框的类名</td>
<td>-</td>
</tr>
<tr>
<td>only-show-pane</td>
<td>Boolean</td>
<td>只显示日期框</td>
<td>-</td>
</tr>
<tr>
<td>renderHtml</td>
<td>HTMLElement, Boolean</td>
<td>定义日期下拉框渲染的位置，如果为<code>true</code>则渲染到body中，可以指定渲染的元素</td>
<td>false</td>
</tr>
</tbody>
</table>
<h3 id="datepicker-event" class="anchor-title">DatePicker event <a class="header-anchor" href="#datepicker-event">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>事件名</th>
<th>说明</th>
<th>返回值</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>数据改变时触发,返回已经格式化的日期</td>
<td>date</td>
</tr>
<tr>
<td>clear</td>
<td>开始clearable时有用。点击清空按钮时触发</td>
<td>-</td>
</tr>
<tr>
<td>click-outside</td>
<td>点击外部关闭下拉框时触发</td>
<td>event</td>
</tr>
<tr>
<td>date-click</td>
<td>选中date时触发，自定义触发器时可以使用,返回已经格式化的日期</td>
<td>date</td>
</tr>
</tbody>
</table>
<h3 id="datepicker-slot" class="anchor-title">DatePicker slot <a class="header-anchor" href="#datepicker-slot">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>-</td>
<td>自定义触发器</td>
</tr>
<tr>
<td>paneFooter</td>
<td>自定义日期选择框底部内容</td>
</tr>
</tbody>
</table>
<h3 id="datepicker-methods" class="anchor-title">DatePicker methods <a class="header-anchor" href="#datepicker-methods">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>名称</th>
<th>说明</th>
<th>参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>focus</td>
<td>主动使input获取焦点</td>
<td>-</td>
</tr>
<tr>
<td>blur</td>
<td>主动使input失去焦点</td>
<td>-</td>
</tr>
</tbody>
</table>
<h3 id="ri-qi-ge-shi-shuo-ming" class="anchor-title">日期格式说明 <a class="header-anchor" href="#ri-qi-ge-shi-shuo-ming">#</a></h3>
<p>使用<code>format</code>指定日期格式；使用<code>value-format</code>指定绑定值得格式。</p>
<p>默认组件返回Date对象格式的日期。以下示例以日期<code>2020-01-01 03:09:01</code>说明。</p>
<p><Alter type="warning">请注意大小写</Alter></p>
<table class="doc-table"><thead>
<tr>
<th>格式</th>
<th>说明</th>
<th>示例</th>
</tr>
</thead>
<tbody>
<tr>
<td>yyyy</td>
<td>年份（四位）</td>
<td>2020</td>
</tr>
<tr>
<td>yy</td>
<td>年份（两位）</td>
<td>20</td>
</tr>
<tr>
<td>MM</td>
<td>月份（单位数时补0）</td>
<td>01</td>
</tr>
<tr>
<td>M</td>
<td>月份</td>
<td>1</td>
</tr>
<tr>
<td>dd</td>
<td>日期（单位数时补0）</td>
<td>01</td>
</tr>
<tr>
<td>d</td>
<td>日期</td>
<td>1</td>
</tr>
<tr>
<td>HH</td>
<td>小时，24小时制（单位数时补0））</td>
<td>03</td>
</tr>
<tr>
<td>H</td>
<td>小时，24小时制</td>
<td>3</td>
</tr>
<tr>
<td>hh</td>
<td>小时，12小时制（单位数时补0））</td>
<td>03</td>
</tr>
<tr>
<td>h</td>
<td>小时，12小时制</td>
<td>3</td>
</tr>
<tr>
<td>mm</td>
<td>分钟（单位数时补0））</td>
<td>09</td>
</tr>
<tr>
<td>m</td>
<td>分钟</td>
<td>9</td>
</tr>
<tr>
<td>ss</td>
<td>秒钟（单位数时补0））</td>
<td>01</td>
</tr>
<tr>
<td>s</td>
<td>秒钟</td>
<td>1</td>
</tr>
<tr>
<td>A</td>
<td>上午与下午（大写）</td>
<td>AM/PM</td>
</tr>
<tr>
<td>a</td>
<td>上午与下午（小写）</td>
<td>am/pm</td>
</tr>
<tr>
<td>WW</td>
<td>周（单位数时补0）</td>
<td>01</td>
</tr>
<tr>
<td>W</td>
<td>周</td>
<td>1</td>
</tr>
<tr>
<td>timestamp</td>
<td>JS时间戳，仅<code>value-format</code>可用</td>
<td>1577819341000</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "monkey-view-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('DatePicker',{attrs:{"placeholder":"请选择日期","clearable":""}})],1),_vm._v(" "),_c('Col',[_c('DatePicker',{attrs:{"type":"daterange","placement":"bottom-end","placeholder":"请选择日期范围","clearable":""}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('DatePicker',{attrs:{"type":"year","placeholder":"请选择年","clearable":""}})],1),_vm._v(" "),_c('Col',[_c('DatePicker',{attrs:{"type":"month","placeholder":"请选择月","clearable":""}})],1),_vm._v(" "),_c('Col',[_c('DatePicker',{attrs:{"type":"week","placeholder":"请选择周","clearable":""}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('DatePicker',{attrs:{"type":"datetime","placeholder":"请选择日期时间","clearable":""}})],1),_vm._v(" "),_c('Col',[_c('DatePicker',{attrs:{"type":"datetimerange","placeholder":"请选择日期时间范围","clearable":""}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('DatePicker',{attrs:{"type":"date","placeholder":"请选择日期","shortcuts":_vm.shortcuts,"clearable":""}})],1),_vm._v(" "),_c('Col',[_c('DatePicker',{attrs:{"type":"daterange","placeholder":"请选择日期范围","shortcuts":_vm.shortcutsrange,"clearable":""}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                shortcuts: [
                    {
                      text: '今天',
                      onClick(picker){
                          let date = new Date();
                          picker.setValue(date);
                      }
                    },
                    {
                      text: '昨天',
                      onClick(picker){
                          let date = new Date();
                          date.setDate(date.getDate() - 1);
                          picker.setValue(date);
                      }
                    },
                    {
                      text: '一周之前的某一天',
                      onClick(picker){
                          let date = new Date();
                          date.setDate(date.getDate() - 7);
                          picker.setValue(date);
                      }
                    }
                ],
                shortcutsrange: [
                    {
                      text: '最近一周',
                      onClick(picker){
                          let date1 = new Date();
                          let date2 = new Date();
                          date1.setDate(date1.getDate() - 7);
                          picker.setValue([date1, date2]);
                      }
                    },
                    {
                      text: '一个月',
                      onClick(picker){
                          let date1 = new Date();
                          let date2 = new Date();
                          date1.setDate(date1.getDate() - 30);
                          picker.setValue([date1, date2]);
                      }
                    },
                    {
                      text: '三个月',
                      onClick(picker){
                          let date1 = new Date();
                          let date2 = new Date();
                          date1.setDate(date1.getDate() - 90);
                          picker.setValue([date1, date2]);
                      }
                    }
                ],
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo4": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('DatePicker',{attrs:{"type":"date","placeholder":"请选择日期","disabled-date":_vm.disabledDate,"clearable":""}})],1),_vm._v(" "),_c('Col',[_c('DatePicker',{attrs:{"type":"daterange","placeholder":"请选择日期范围","disabled-date":_vm.disabledDate,"clearable":""}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                
            }
        },
        methods: {
            disabledDate(date){
                return date && new Date(date).getTime() < Date.now();
            },
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo5": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('DatePicker',{attrs:{"type":"date","placeholder":"请选择日期","format":"yyyy年MM月dd日","clearable":""}})],1),_vm._v(" "),_c('Col',[_c('DatePicker',{attrs:{"type":"daterange","placeholder":"请选择日期范围","format":"yyyy/MM/dd","clearable":""}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                
            }
        },
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo6": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('p',[_vm._v("默认为Date对象")]),_vm._v(" "),_c('p',[_vm._v("value: "+_vm._s(_vm.date1))]),_vm._v(" "),_c('DatePicker',{attrs:{"placeholder":"请选择日期","clearable":""},model:{value:(_vm.date1),callback:function ($$v) {_vm.date1=$$v},expression:"date1"}})],1),_vm._v(" "),_c('Col',[_c('p',[_vm._v("使用value-format")]),_vm._v(" "),_c('p',[_vm._v("value: "+_vm._s(_vm.date2))]),_vm._v(" "),_c('DatePicker',{attrs:{"placeholder":"请选择日期范围","value-format":"yyyy年MM月dd日","clearable":""},model:{value:(_vm.date2),callback:function ($$v) {_vm.date2=$$v},expression:"date2"}})],1),_vm._v(" "),_c('Col',[_c('p',[_vm._v("时间戳")]),_vm._v(" "),_c('p',[_vm._v("value: "+_vm._s(_vm.date3))]),_vm._v(" "),_c('DatePicker',{attrs:{"placeholder":"请选择日期","value-format":"timestamp","clearable":""},model:{value:(_vm.date3),callback:function ($$v) {_vm.date3=$$v},expression:"date3"}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                date1: '',
                date2: '',
                date3: '',
            }
        },
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo7": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('DatePicker',{attrs:{"placeholder":"请选择日期","multiple":"","clearable":""}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                
            }
        },
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo8": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('DatePicker',{attrs:{"type":"date","placeholder":"请选择时间","show-week-number":"","clearable":""}})],1),_vm._v(" "),_c('Col',[_c('DatePicker',{attrs:{"type":"daterange","placeholder":"请选择日期范围","show-week-number":"","clearable":""}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                
            }
        },
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo9": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('h4',[_vm._v("只读")]),_vm._v(" "),_c('DatePicker',{attrs:{"type":"date","placeholder":"请选择日期","readonly":"","clearable":""}})],1),_vm._v(" "),_c('Col',[_c('h4',[_vm._v("不可输入")]),_vm._v(" "),_c('DatePicker',{attrs:{"type":"daterange","placeholder":"请选择日期范围","editable":false,"clearable":""}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                
            }
        },
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo10": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('DatePicker',{attrs:{"type":"date","placeholder":"请选择日期","disabled":"","clearable":""}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                
            }
        },
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo11": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('DatePicker',{attrs:{"type":"date","placeholder":"请选择日期","open":_vm.open}},[_c('Button',{attrs:{"type":"text"},on:{"click":function($event){_vm.open = !_vm.open}}},[_vm._v("触发日期框打开关闭")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                open: false
            }
        },
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo12": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('DatePicker',{attrs:{"type":"date","only-show-pane":""},on:{"change":_vm.handleChange},model:{value:(_vm.pickerDate),callback:function ($$v) {_vm.pickerDate=$$v},expression:"pickerDate"}},[_c('template',{slot:"paneFooter"},[_c('Button',{attrs:{"size":"small"},on:{"click":_vm.handleClear}},[_vm._v("清除")])],1)],2)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                pickerDate: ''
            }
        },
        methods: {
            handleChange(value){
                this.$Message.info('selectd value is ' + value)
            },
            handleClear(){
                this.pickerDate = '';
            }   
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo13": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('h4',[_vm._v("Mini")]),_vm._v(" "),_c('DatePicker',{attrs:{"type":"date","placeholder":"请选择日期","size":"mini"}})],1),_vm._v(" "),_c('Col',[_c('h4',[_vm._v("Small")]),_vm._v(" "),_c('DatePicker',{attrs:{"type":"date","placeholder":"请选择日期范围","size":"small"}})],1),_vm._v(" "),_c('Col',[_c('h4',[_vm._v("Default")]),_vm._v(" "),_c('DatePicker',{attrs:{"type":"date","placeholder":"请选择日期范围"}})],1),_vm._v(" "),_c('Col',[_c('h4',[_vm._v("Large")]),_vm._v(" "),_c('DatePicker',{attrs:{"type":"date","placeholder":"请选择日期范围","size":"large"}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                
            }
        },
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  